<template>
  <div :class="{row: true, 'row-animation': !scroll}">
    <div class="question-box">
      <div :class="{question: true, 'question-animation': !scroll}" @click="goToQuestion" :title='"Go back to " + object.question.text'>
        <div class="text">{{ object.question.text }}</div>
      </div>
    </div>
    <div class="answer-box">
      <div :class="{answer: true, 'answer-animation': !scroll}">
        <div class="text">{{ getHint }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    object: Object
  },
  methods: {
    goToQuestion() {
      this.$emit('goToQuestion', { questionId: this.object.question.id, answerId: this.object.answer.id });
    }
  },
  computed: {
    scroll() {
      if(document.querySelector('.main').offsetHeight + document.querySelector('.row-box').offsetHeight > window.innerHeight) {
        return true;
      } else {
        return false;
      }
    },
    getHint() {
      if(this.object.answer.hint.trim() != '') {
        return this.object.answer.hint;
      } else {
        let array = this.object.answer.text.split(' ');
        if(array[0] && array[1]) {
          return `${array[0]} ${array[1]}...`;
        } else {
          return `${array[0]}...`;
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.row {
  width: 100%;
  height: auto;
  min-height: 8rem;
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.row-animation {
  animation: row-appear 0.8s linear forwards;
}

@keyframes row-appear {
  0% {
    min-height: 0;
  }
  50% {
    min-height: 0;
  }
  100% {
    min-height: 8rem;
  }
}

.question-box {
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: 1050px) {
    align-items: center;
  }
  @media (max-width: 750px) {
    min-height: 6rem;
    height: auto;
    width: 100%;
    flex: unset;
    margin-bottom: 1rem;
  }
}

.question {
  width: 100%;
  min-height: 6rem;
  background-color: #0e9c8e;
  border-radius: 0.5rem;
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  position: relative;
  padding-bottom: 1rem;
  padding-top: 1rem;
  @media (max-width: 1050px) {
    width: 90%;
  }
  cursor: pointer;

  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2rem;
    color: white;
    word-break: break-word;
  }
}

.question-animation {
  animation: question-appear 0.8s linear forwards;
}

@keyframes question-appear {
  0% {
    opacity: 0;
    min-height: 0;
  }
  50% {
    opacity: 0;
    min-height: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    min-height: 6rem;
  }
}

.answer-box {
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 750px) {
    min-height: 4rem;
    height: auto;
    width: 100%;
    flex: unset;
  }
}

.answer {
  width: 90%;
  min-height: 4rem;
  background-color: #edc270;
  border-radius: 0.5rem;
  display: flex;
  margin-bottom: 1rem;
  color: #4f4f4f;
  transition: 0.2s;
  padding-top: 1rem;
  padding-bottom: 1rem;

  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2rem;
    word-break: break-word;
  }
}

.answer-animation {
  animation: answer-appear 0.8s linear forwards;
}

@keyframes answer-appear {
  0% {
    opacity: 0;
    min-height: 0;
  }
  50% {
    opacity: 0;
    min-height: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    min-height: 4rem;
  }
}


</style>